import React from "react";
import { CardMedia } from "Components/Base/Surfaces/Card/CardMedia";
import { Card } from "Components/Base/Surfaces/Card/Card";
import { CardContent } from "Components/Base/Surfaces/Card/CardContent";
import { Typography } from "Components/Base/DataDisplay/Typography";
import styled from "styled-components";
import { CardActions } from "@mui/material";

const StyledMUIImageCard = styled(Card)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  button:hover {
    transform: none;
  }

  .MuiCardMedia-root {
    height: 70px;
    min-height: 70px;
    max-height: 70px;
    width: 120%;
    position: relative;
    left: -10%;
  }
`;

const StyledCardContent = styled(CardContent)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  max-height: 195px;

  .MuiBox-root {
    margin: 0;
  }
`;

/**
 * A card component that displays an image, title, and optional actions.
 * Designed to optionally include additional children components inside the card content.
 *
 * @param {string} props.image - The URL of the image to display on the card. If not provided, a placeholder is shown.
 * @param {string} props.title - The title of the card, displayed below the image.
 * @param {React.Node} props.actions - Components or elements to be displayed as card actions (typically buttons).
 * @param {React.Node} props.children - Additional content to be displayed inside the card content area, below the title.
 * @param {string} [props.className] - Optional custom class name to apply to the card for styling.
 * @param {string} [props.hovertext] - Text to display as a tooltip or hovertext over the image.
 * @returns {React.Component} The `ImageCard` component displaying the image, title, and actions provided.
 */
const ImageCard = ({
  image,
  title,
  actions,
  children,
  className,
  hovertext,
}) => (
  <StyledMUIImageCard className={className} sx={{ boxShadow: "lg" }}>
    <StyledCardContent>
      {image ? (
        <CardMedia image={image} title={hovertext} component="img" />
      ) : (
        <div className="card-no-image-margin-top"></div>
      )}
      <Typography noWrap variant="h3">
        {title}
      </Typography>
      {children}
    </StyledCardContent>
    <CardActions>{actions}</CardActions>
  </StyledMUIImageCard>
);

export default ImageCard;
